import React, {useCallback, useEffect} from 'react'
import { observer, useLocalObservable } from "mobx-react-lite"
import { useNavigate } from "@reach/router"
import Layout from '../layout/Layout'
import classes from './AppBuy.module.scss'
import classesModel from './SubSuccessModal.module.scss'
import CreditIcon from "../../components/CreditIcon";
import Radio from "@mui/material/Radio";
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CircularProgress from '@mui/material/CircularProgress';
import Skeleton from '@mui/material/Skeleton';
import Button from "@mui/material/Button";
import LoadingButton from "@mui/lab/LoadingButton";
import {ReactComponent as PaypalIcon} from '../../images/paypal.svg'
import {ReactComponent as CreditCard} from '../../images/credit-card.svg'
import userStore from '../common/userStore'

import { fetchApps, generateAppToken, createAppOrder, redeemAppOrder, showAppOrder, captureOrder } from './AccountAPI'

import {
    PayPalScriptProvider,
    PayPalHostedFieldsProvider,
    PayPalHostedField,
    usePayPalHostedFields,
} from "@paypal/react-paypal-js";
import {runInAction, toJS} from "mobx";
import Backdrop from "@mui/material/Backdrop";
import BaseModal from "./BaseModal";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";


const features = "height=500, width=800, toolbar=no, menubar=no, scrollbars=no,resizable=no, location=no, status=no";


const getHostedFieldsValue = () => {
    const rs = {};
    const cardholderName = document.getElementsByName("card-holder-name")[0].value;
    const streetAddress = document.getElementsByName("card-billing-address-street")[0].value;
    const extendedAddress = document.getElementsByName("card-billing-address-unit")[0].value;
    const region = document.getElementsByName("card-billing-address-state")[0].value;
    const locality = document.getElementsByName("card-billing-address-city")[0].value;
    const postalCode = document.getElementsByName("card-billing-address-zip")[0].value;
    const countryCodeAlpha2 = document.getElementsByName("card-billing-address-country")[0].value;
    if (cardholderName) {
        rs.cardholderName = cardholderName;
    }
    if (streetAddress) {
        rs.billingAddress = rs.billingAddress || {};
        rs.billingAddress.streetAddress = streetAddress;
    }
    if (extendedAddress) {
        rs.billingAddress = rs.billingAddress || {};
        rs.billingAddress.extendedAddress = extendedAddress;
    }
    if (region) {
        rs.billingAddress = rs.billingAddress || {};
        rs.billingAddress.region = region;
    }
    if (locality) {
        rs.billingAddress = rs.billingAddress || {};
        rs.billingAddress.locality = locality;
    }
    if (postalCode) {
        rs.billingAddress = rs.billingAddress || {};
        rs.billingAddress.postalCode = postalCode;
    }
    if (countryCodeAlpha2) {
        rs.billingAddress = rs.billingAddress || {};
        rs.billingAddress.countryCodeAlpha2 = countryCodeAlpha2;
    }
    return rs;
}

const PayPalHostedFieldsSubmit = ({state}) => {

    const hostedFields = usePayPalHostedFields();
    console.log('hostedFields 1', hostedFields)

    const submitHandler = useCallback(async () => {
        state.fail = false;
        state.submitting = true;
        // console.log('keys', Object.values(hostedFields.cardFields.getState().fields));
        const isFormInvalid = Object.values(hostedFields.cardFields.getState().fields).some(
                (field) => !field.isValid
            );
        if (isFormInvalid) {
            state.fail = true
            return false;
        }
        const hostedFieldsValue = getHostedFieldsValue();
        console.log('hostedFields 2', hostedFields)
        console.log("hostedFieldsValue", hostedFieldsValue)
        try {
            const order = await hostedFields.cardFields.submit(hostedFieldsValue);
            console.log("submit order", order)
            // capture order
            const capture = await captureOrder({orderId: state.orderId});
            console.log("capture order", capture)
            if ((capture.status === 'APPROVED' || capture.status === 'COMPLETED')
                && capture.purchase_units && capture.purchase_units[0]
                && capture.purchase_units[0].payments
                && capture.purchase_units[0].payments.captures && capture.purchase_units[0].payments.captures[0]
                && capture.purchase_units[0].payments.captures[0].status
                && capture.purchase_units[0].payments.captures[0].status === 'COMPLETED') {
                state.success = true;
                window.fpr("referral", {email: userStore.user.email});
            } else {
                state.success = false;
                state.fail = true;
            }
            state.submitting = false;
        } catch (e) {
            console.error(e)
            state.submitting = false
        }
    }, [hostedFields, state])

    useEffect(() => {
        state.submitHandler = submitHandler;
        return () => {
            state.submitHandler = null;
        }
    }, [state, submitHandler])
    return <div></div>
}

const CardBuy = observer(({location}) => {

    const navigate = useNavigate();

    const state = useLocalObservable(() => ({
        payMethod: "card", // paypal card
        appId: null,
        apps: [],
        clientToken: null,
        clientId: null,
        payingWin: null,
        submitting: false,
        redeeming: false,
        orderId: null,
        checkOrderTimeout: null,
        success: false,
        fail: false,
        redeemFail: false,
        redeemErrorMsg: '',
        loadingToken: false,
        get ready() {
            return !!this.app.appId
        },
        get submitDisabled() {
            return !this.ready || this.success
        },
        get isOpenedWin() {
            return this.payingWin != null && !this.payingWin.closed
        },
        closePayingWin: () => {
            state.fail = !state.success
            state.submitting = false
            state.payingWin && state.payingWin.close()
            state.payingWin = null
        },
        loadApps: async (appId) => {
            state.appId = appId;
            const apps = await fetchApps({})
            //console.log("apps", apps)
            state.apps = apps;
        },
        loadToken: async () => {
            if (!state.showCard) {
                return;
            }
            if (state.loadingToken) {
                return;
            }
            if (state.clientToken) {
                return;
            }
            state.loadingToken = true
            try {
                let resp = await generateAppToken({});
                // console.log("generateAppToken = ", resp)
                if (resp.client_token) {
                    state.clientToken = resp.client_token;
                    state.clientId = "AfOMW6RqyZeVQ_SP3AwmBhUEZYnoG9R9mop4adJ9X2VmqA4WcljOPG5XNHk_Ml3SpQGpeZ-eddX2pav2";
                } else {
                    // for debug
                    state.clientToken = resp.clientToken;
                    state.clientId = resp.clientId;
                }
            } catch (e) {
                console.error(e)
            } finally {
                state.loadingToken = false
            }
        },
        changeMethod: (method) => {
            if (!state.ready || state.submitting) {
                return;
            }
            state.payMethod = method
            console.log('pay method ', state.payMethod)
            state.loadToken()
        },
        openPaypal: async () => {
            console.log('open paypal', state.appId)
            state.submitting = true
            state.payingWin = window.open('about:blank', '_blank', features)
            try {
                let rs = await createAppOrder({appId: state.appId});
                state.orderId = rs.id
                runInAction(() => {
                    state.payingWin.location.href = rs.links[1].href
                    state.checkOrderTimeout = setTimeout(state.checkOrder, 500);
                })
            } catch (e) {
                state.closePayingWin()
            }
        },
        redeemOrder: async () => {
            state.redeeming = true
            try {
                const rs = await redeemAppOrder({code: document.getElementsByName("redeem-code")[0].value.trim()});
                state.redeeming = false
                if (rs.code == 0)
                    state.success = true
                else
                {
                    state.redeemFail = true;
                    console.log(rs)
                    state.redeemErrorMsg = rs.message;
                }
            } catch (e) {
                state.redeeming = false;
                state.redeemFail = true;
                console.log(e)
                state.redeemErrorMsg = e.message;
                throw e;
            }
        },
        createOrder: async () => {
            state.submitting = true
            try {
                let rs = await createAppOrder({appId: state.appId});
                state.orderId = rs.id;
                return rs.id;
            } catch (e) {
                state.submitting = false
                throw e;
            }
        },
        checkOrder: async () => {
            try {
                const rs = await showAppOrder({orderId: state.orderId})
                if (rs.status === 'APPROVED' || rs.status === 'COMPLETED') {
                    state.success = true;
                    window.fpr("referral", {email: userStore.user.email});
                    state.closePayingWin();
                    return;
                }
                if (!state.payingWin && !state.showCard) {
                    return;
                }
                state.checkOrderTimeout = setTimeout(state.checkOrder, 500);
            } catch (e) {
                
            }
        },
        submitHandler: null,
        back: () => {
            navigate(-1)
            // navigate('/', {replace:true})
        },
        submit: () => {
            if (state.showCard) {
                state.submitHandler()
            } else {
                state.openPaypal()
            }
        },
        redeem: () => {
            state.redeemOrder()
        },
        get app() {
            let id = this.appId;
            return this.apps.find(app => app.appId === id) || {}
        },
        get showCard() {
            return this.payMethod === 'card'
        }
    }));

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const appId = params.get('app-id')
        state.loadApps(appId);
        state.loadToken();
        return () => {
            state.payingWin = null;
            state.checkOrderTimeout && clearTimeout(state.checkOrderTimeout)
        }
    }, [state]);

    // if (!(state.clientToken && state.clientId)) {
    //     return <Layout></Layout>
    // }

    return <Layout>
        <SuccessModal open={state.success} />
        <Backdrop open={state.isOpenedWin} style={{zIndex: 10000}} className={classes.waiting}>
            <CircularProgress />
            <p>Please do not close this page. You will be automatically redirected to home after complete</p>
            <Button variant="contained" disableElevation className={classes.waitingClose} onClick={state.closePayingWin}>I've made the payment</Button>
        </Backdrop>
        <div className={classes.root}>
            <div className={classes.content}>
                <h1>Checkout</h1>
                <div className={classes.plan}>
                    <div className={classes.desc}>
                        {state.app.name}
                    </div>
                    <div className={classes.price}> ${state.app.price}.00</div>
                </div>
                <div className={classes.detail}>
                    <div className={classes.item}>
                        <div className={classes.left}>Subtotal</div>
                        <div className={classes.right}>${state.app.price}.00</div>
                    </div>
                    <div className={classes.item}>
                        <div className={classes.left}>Tax</div>
                        <div className={classes.right}>$0.00</div>
                    </div>
                    <div className={classes.line}></div>
                    <div className={classes.item}>
                        <div className={classes.left}>Total</div>
                        <div className={classes.right}>${state.app.price}.00</div>
                    </div>
                </div>
                <div className={classes.redeem}>
                    <div className={classes.redeemTitle}>Enter a redeem or promotional code</div>
                    <div className={classes.actions} style={{margin:0, justifyContent: 'flex-start'}}>
                        <OutlinedInput id="redeem-code" name="redeem-code" style={{marginRight: 10}} autoComplete="off" size="small" placeholder="Enter Code" />
                        <LoadingButton
                            className={classes.action}
                            variant="contained"
                            disableElevation
                            loading={state.redeeming}
                            onClick={state.redeem}
                        >Apply</LoadingButton>
                    </div>
                    {state.redeemFail && <div className={classes.error}>
                        <ErrorOutlineIcon size="small" />
                        {state.redeemErrorMsg}
                        {/* Invalid code, please try another */}
                    </div>}
                </div>
                <div className={classes.methods}>
                    <h2>Payment method</h2>
                    <div className={classes.items}>
                        <label className={classes.item} onClick={() => state.changeMethod("card")}>
                            <Radio checked={state.payMethod === 'card'} value="card" size="small" />
                            <CreditCard className={classes.creditCard} />
                        </label>
                        <label className={classes.item} onClick={() => state.changeMethod("paypal")}>
                            <Radio checked={state.payMethod === 'paypal'} value="paypal" size="small" />
                            <PaypalIcon className={classes.paypal} />
                        </label>
                    </div>
                </div>

                {state.fail && <div className={classes.error}>
                    <ErrorOutlineIcon size="small" />
                    Prease review your billing information or try another payment method
                </div>}

                {/*{subStatusCheck.isNew ? <TrialInfo checkoutPlan={checkoutPlan} /> : <ChangeInfo checkoutPlan={checkoutPlan} />}*/}

                {state.showCard ? <div className={classes.form}>
                    {state.clientToken && state.clientId ? (<PayPalScriptProvider
                        options={{
                            "client-id": state.clientId,
                            components: "buttons,hosted-fields",
                            "data-client-token": toJS(state.clientToken),
                            intent: "capture",
                            vault: false,
                        }}
                    >
                        <PayPalHostedFieldsProvider createOrder={state.createOrder} notEligibleError={<div>数据不对</div>} >
                            <div className={classes.fieldCard}>
                                <label htmlFor="card-number">
                                    Card Number
                                    <span style={{color: "#dc3545"}}>*</span>
                                </label>
                                <PayPalHostedField
                                    id="card-number"
                                    className={classes.input}
                                    hostedFieldType="number"
                                    options={{ selector: "#card-number" }}
                                />
                            </div>
                            <div className={classes.fieldLine}>
                                <div className={classes.fieldLineCol}>
                                    <label htmlFor="cvv">
                                        CVV
                                        <span style={{color: "#dc3545"}}>*</span>
                                    </label>
                                    <PayPalHostedField
                                        id="cvv"
                                        className={classes.input}
                                        hostedFieldType="cvv"
                                        options={{ selector: "#cvv" }}
                                    />
                                </div>
                                <div className={classes.fieldLineCol}>
                                    <label htmlFor="expiration-date">
                                        Expiration Date
                                        <span style={{color: "#dc3545"}}>*</span>
                                    </label>
                                    <PayPalHostedField
                                        id="expiration-date"
                                        className={classes.input}
                                        hostedFieldType="expirationDate"
                                        options={{
                                            selector: "#expiration-date",
                                            placeholder: "MM/YY",
                                        }}
                                    />
                                </div>
                            </div>

                            <div className={classes.fieldCard}>
                                <label htmlFor="card-holder-name">Name on Card</label>
                                <div >
                                    <OutlinedInput className={classes.fieldInput}
                                        // value={changeForm.email}
                                        // onChange={changeForm.handleEmail}
                                                   id="card-holder-name"
                                                   name="card-holder-name"
                                                   autoComplete="off"
                                                   size="small"
                                                   placeholder="Card Holder Name" />
                                </div>
                            </div>

                            <div className={classes.fieldCard}>
                                <label htmlFor="card-billing-address-street">Billing Address</label>
                                <div>
                                    <OutlinedInput className={classes.fieldInput}
                                        // value={changeForm.email}
                                        // onChange={changeForm.handleEmail}
                                                   id="card-billing-address-street"
                                                   name="card-billing-address-street"
                                                   autoComplete="off"
                                                   size="small"
                                                   placeholder="Street" />
                                </div>
                            </div>
                            <div className={classes.fieldAddress}>
                                <OutlinedInput className={classes.fieldInput}
                                    // value={changeForm.email}
                                    // onChange={changeForm.handleEmail}
                                               id="card-billing-address-unit"
                                               name="card-billing-address-unit"
                                               autoComplete="off"
                                               size="small"
                                               placeholder="Apt, Suite Number(Optional)" />
                            </div>
                            <div className={classes.fieldAddress}>
                                <OutlinedInput className={classes.fieldInput}
                                    // value={changeForm.email}
                                    // onChange={changeForm.handleEmail}
                                               id="card-billing-address-city"
                                               name="card-billing-address-city"
                                               autoComplete="off"
                                               size="small"
                                               placeholder="City" />
                            </div>
                            <div className={classes.fieldAddress}>
                                <OutlinedInput className={classes.fieldInput}
                                    // value={changeForm.email}
                                    // onChange={changeForm.handleEmail}
                                               id="card-billing-address-state"
                                               name="card-billing-address-state"
                                               autoComplete="off"
                                               size="small"
                                               placeholder="State" />
                            </div>
                            <div className={classes.fieldAddress}>
                                <OutlinedInput className={classes.fieldInput}
                                    // value={changeForm.email}
                                    // onChange={changeForm.handleEmail}
                                               id="card-billing-address-zip"
                                               name="card-billing-address-zip"
                                               autoComplete="off"
                                               size="small"
                                               placeholder="Postal Code" />
                            </div>
                            <div className={classes.fieldAddress}>
                                <Select className={classes.fieldInput}
                                        labelId="card-billing-address-country-label"
                                        name="card-billing-address-country"
                                        id="card-billing-address-country"
                                        placeholder="country code"
                                        displayEmpty={true}
                                        defaultValue={""}
                                        renderValue={(selected) => {
                                            //console.log("selected", selected)
                                            if (!selected) {
                                                return <span className={classes.fieldPlaceholder}>Country</span>;
                                            }
                                            return <span>{CountryRegion.find(v => v.value === selected).label}</span>;
                                        }}
                                >
                                    {CountryRegion.map(v => <MenuItem key={v.value} value={v.value}>{v.label}</MenuItem>)}
                                </Select>
                            </div>
                            <PayPalHostedFieldsSubmit state={state} />
                        </PayPalHostedFieldsProvider>
                    </PayPalScriptProvider>) : <div>
                        <Skeleton className={classes.skeleton} />
                        <Skeleton className={classes.skeleton} />
                        <Skeleton className={classes.skeleton} />
                        <Skeleton className={classes.skeleton} />
                        <Skeleton className={classes.skeleton} />
                        <Skeleton className={classes.skeleton} />
                        <Skeleton className={classes.skeleton} />
                        <Skeleton className={classes.skeleton} />
                        <Skeleton className={classes.skeleton} />
                    </div> }
                </div> : null}

                <div className={classes.actions}>
                    <Button
                        variant="outlined"
                        className={classes.action} onClick={state.back}>Not now</Button>
                    <LoadingButton
                        className={classes.action}
                        variant="contained"
                        disableElevation
                        disabled={state.submitDisabled}
                        loading={state.submitting}
                        onClick={state.submit}
                    >Submit</LoadingButton>
                </div>
            </div>
        </div>
    </Layout>
});

export default CardBuy;

const SuccessModal = observer(({open}) => {
    const nav = useNavigate()

    return <BaseModal open={open} onClose={() => nav('/')} classes={classesModel}>
        <CheckCircleOutlineIcon className={classesModel.icon} />
        <div className={classesModel.text}>Your order is completed</div>
        <div className={classesModel.text}>Please register your product on the app</div>
        <Button className={classesModel.browseAction} variant="contained" disableElevation onClick={() => nav('/')}>Continue to Browse</Button>
    </BaseModal>
})

// --------------------



const CountryRegion = [
    {"label": "AFGHANISTAN", value: "AF"},
    {"label": "ALBANIA", value: "AL"},
    {"label": "ALGERIA", value: "DZ"},
    {"label": "AMERICAN SAMOA", value: "AS"},
    {"label": "ANDORRA", value: "AD"},
    {"label": "ANGOLA", value: "AO"},
    {"label": "ANGUILLA", value: "AI"},
    {"label": "ANTARCTICA", value: "AQ"},
    {"label": "ANTIGUA & BARBUDA", value: "AG"},
    {"label": "ARGENTINA", value: "AR"},
    {"label": "ARMENIA", value: "AM"},
    {"label": "ARUBA", value: "AW"},
    {"label": "AUSTRALIA", value: "AU"},
    {"label": "AUSTRIA", value: "AT"},
    {"label": "AZERBAIJAN", value: "AZ"},
    {"label": "BAHAMAS", value: "BS"},
    {"label": "BAHRAIN", value: "BH"},
    {"label": "BANGLADESH", value: "BD"},
    {"label": "BARBADOS", value: "BB"},
    {"label": "BELARUS", value: "BY"},
    {"label": "BELGIUM", value: "BE"},
    {"label": "BELIZE", value: "BZ"},
    {"label": "BENIN", value: "BJ"},
    {"label": "BERMUDA", value: "BM"},
    {"label": "BHUTAN", value: "BT"},
    {"label": "BOLIVIA", value: "BO"},
    {"label": "BOSNIA & HERZEGOVINA", value: "BA"},
    {"label": "BOTSWANA", value: "BW"},
    {"label": "BOUVET ISLAND", value: "BV"},
    {"label": "BRAZIL", value: "BR"},
    {"label": "BRITISH INDIAN OCEAN TERRITORY", value: "IO"},
    {"label": "BRITISH VIRGIN ISLANDS", value: "VG"},
    {"label": "BRUNEI", value: "BN"},
    {"label": "BULGARIA", value: "BG"},
    {"label": "BURKINA FASO", value: "BF"},
    {"label": "BURUNDI", value: "BI"},
    {"label": "CAMBODIA", value: "KH"},
    {"label": "CAMEROON", value: "CM"},
    {"label": "CANADA", value: "CA"},
    {"label": "CAPE VERDE", value: "CV"},
    {"label": "CAYMAN ISLANDS", value: "KY"},
    {"label": "CENTRAL AFRICAN REPUBLIC", value: "CF"},
    {"label": "CHAD", value: "TD"},
    {"label": "CHILE", value: "CL"},
    {"label": "CHINA", value: "C2"},
    {"label": "CHRISTMAS ISLAND", value: "CX"},
    {"label": "COCOS (KEELING) ISLANDS", value: "CC"},
    {"label": "COLOMBIA", value: "CO"},
    {"label": "COMOROS", value: "KM"},
    {"label": "CONGO - BRAZZAVILLE", value: "CG"},
    {"label": "CONGO - KINSHASA", value: "CD"},
    {"label": "COOK ISLANDS", value: "CK"},
    {"label": "COSTA RICA", value: "CR"},
    {"label": "CÔTE D’IVOIRE", value: "CI"},
    {"label": "CROATIA", value: "HR"},
    {"label": "CUBA", value: "CU"},
    {"label": "CYPRUS", value: "CY"},
    {"label": "CZECH REPUBLIC", value: "CZ"},
    {"label": "DENMARK", value: "DK"},
    {"label": "DJIBOUTI", value: "DJ"},
    {"label": "DOMINICA", value: "DM"},
    {"label": "DOMINICAN REPUBLIC", value: "DO"},
    {"label": "ECUADOR", value: "EC"},
    {"label": "EGYPT", value: "EG"},
    {"label": "EL SALVADOR", value: "SV"},
    {"label": "EQUATORIAL GUINEA", value: "GQ"},
    {"label": "ERITREA", value: "ER"},
    {"label": "ESTONIA", value: "EE"},
    {"label": "ETHIOPIA", value: "ET"},
    {"label": "FALKLAND ISLANDS", value: "FK"},
    {"label": "FAROE ISLANDS", value: "FO"},
    {"label": "FIJI", value: "FJ"},
    {"label": "FINLAND", value: "FI"},
    {"label": "FRANCE", value: "FR"},
    {"label": "FRENCH GUIANA", value: "GF"},
    {"label": "FRENCH POLYNESIA", value: "PF"},
    {"label": "FRENCH SOUTHERN TERRITORIES", value: "TF"},
    {"label": "GABON", value: "GA"},
    {"label": "GAMBIA", value: "GM"},
    {"label": "GEORGIA", value: "GE"},
    {"label": "GERMANY", value: "DE"},
    {"label": "GHANA", value: "GH"},
    {"label": "GIBRALTAR", value: "GI"},
    {"label": "GREECE", value: "GR"},
    {"label": "GREENLAND", value: "GL"},
    {"label": "GRENADA", value: "GD"},
    {"label": "GUADELOUPE", value: "GP"},
    {"label": "GUAM", value: "GU"},
    {"label": "GUATEMALA", value: "GT"},
    {"label": "GUERNSEY", value: "GG"},
    {"label": "GUINEA", value: "GN"},
    {"label": "GUINEA-BISSAU", value: "GW"},
    {"label": "GUYANA", value: "GY"},
    {"label": "HAITI", value: "HT"},
    {"label": "HEARD & MCDONALD ISLANDS", value: "HM"},
    {"label": "HONDURAS", value: "HN"},
    {"label": "HONG KONG SAR CHINA", value: "HK"},
    {"label": "HUNGARY", value: "HU"},
    {"label": "ICELAND", value: "IS"},
    {"label": "INDIA", value: "IN"},
    {"label": "INDONESIA", value: "ID"},
    {"label": "IRAN", value: "IR"},
    {"label": "IRAQ", value: "IQ"},
    {"label": "IRELAND", value: "IE"},
    {"label": "ISLE OF MAN", value: "IM"},
    {"label": "ISRAEL", value: "IL"},
    {"label": "ITALY", value: "IT"},
    {"label": "JAMAICA", value: "JM"},
    {"label": "JAPAN", value: "JP"},
    {"label": "JERSEY", value: "JE"},
    {"label": "JORDAN", value: "JO"},
    {"label": "KAZAKHSTAN", value: "KZ"},
    {"label": "KENYA", value: "KE"},
    {"label": "KIRIBATI", value: "KI"},
    {"label": "KUWAIT", value: "KW"},
    {"label": "KYRGYZSTAN", value: "KG"},
    {"label": "LAOS", value: "LA"},
    {"label": "LATVIA", value: "LV"},
    {"label": "LEBANON", value: "LB"},
    {"label": "LESOTHO", value: "LS"},
    {"label": "LIBERIA", value: "LR"},
    {"label": "LIBYA", value: "LY"},
    {"label": "LIECHTENSTEIN", value: "LI"},
    {"label": "LITHUANIA", value: "LT"},
    {"label": "LUXEMBOURG", value: "LU"},
    {"label": "MACEDONIA", value: "MK"},
    {"label": "MADAGASCAR", value: "MG"},
    {"label": "MALAWI", value: "MW"},
    {"label": "MALAYSIA", value: "MY"},
    {"label": "MALDIVES", value: "MV"},
    {"label": "MALI", value: "ML"},
    {"label": "MALTA", value: "MT"},
    {"label": "MARSHALL ISLANDS", value: "MH"},
    {"label": "MARTINIQUE", value: "MQ"},
    {"label": "MAURITANIA", value: "MR"},
    {"label": "MAURITIUS", value: "MU"},
    {"label": "MAYOTTE", value: "YT"},
    {"label": "MEXICO", value: "MX"},
    {"label": "MICRONESIA", value: "FM"},
    {"label": "MOLDOVA", value: "MD"},
    {"label": "MONACO", value: "MC"},
    {"label": "MONGOLIA", value: "MN"},
    {"label": "MONTENEGRO", value: "ME"},
    {"label": "MONTSERRAT", value: "MS"},
    {"label": "MOROCCO", value: "MA"},
    {"label": "MOZAMBIQUE", value: "MZ"},
    {"label": "MYANMAR (BURMA)", value: "MM"},
    {"label": "NAMIBIA", value: "NA"},
    {"label": "NAURU", value: "NR"},
    {"label": "NEPAL", value: "NP"},
    {"label": "NETHERLANDS", value: "NL"},
    {"label": "NEW CALEDONIA", value: "NC"},
    {"label": "NEW ZEALAND", value: "NZ"},
    {"label": "NICARAGUA", value: "NI"},
    {"label": "NIGER", value: "NE"},
    {"label": "NIGERIA", value: "NG"},
    {"label": "NIUE", value: "NU"},
    {"label": "NORFOLK ISLAND", value: "NF"},
    {"label": "NORTH KOREA", value: "KP"},
    {"label": "NORTHERN MARIANA ISLANDS", value: "MP"},
    {"label": "NORWAY", value: "NO"},
    {"label": "OMAN", value: "OM"},
    {"label": "PAKISTAN", value: "PK"},
    {"label": "PALAU", value: "PW"},
    {"label": "PALESTINIAN TERRITORIES", value: "PS"},
    {"label": "PANAMA", value: "PA"},
    {"label": "PAPUA NEW GUINEA", value: "PG"},
    {"label": "PARAGUAY", value: "PY"},
    {"label": "PERU", value: "PE"},
    {"label": "PHILIPPINES", value: "PH"},
    {"label": "PITCAIRN ISLANDS", value: "PN"},
    {"label": "POLAND", value: "PL"},
    {"label": "PORTUGAL", value: "PT"},
    {"label": "PUERTO RICO", value: "PR"},
    {"label": "QATAR", value: "QA"},
    {"label": "RÉUNION", value: "RE"},
    {"label": "ROMANIA", value: "RO"},
    {"label": "RUSSIA", value: "RU"},
    {"label": "RWANDA", value: "RW"},
    {"label": "SAMOA", value: "WS"},
    {"label": "SAN MARINO", value: "SM"},
    {"label": "SÃO TOMÉ & PRÍNCIPE", value: "ST"},
    {"label": "SAUDI ARABIA", value: "SA"},
    {"label": "SENEGAL", value: "SN"},
    {"label": "SERBIA", value: "RS"},
    {"label": "SEYCHELLES", value: "SC"},
    {"label": "SIERRA LEONE", value: "SL"},
    {"label": "SINGAPORE", value: "SG"},
    {"label": "SLOVAKIA", value: "SK"},
    {"label": "SLOVENIA", value: "SI"},
    {"label": "SOLOMON ISLANDS", value: "SB"},
    {"label": "SOMALIA", value: "SO"},
    {"label": "SOUTH AFRICA", value: "ZA"},
    {"label": "SOUTH GEORGIA & SOUTH SANDWICH ISLANDS", value: "GS"},
    {"label": "SOUTH KOREA", value: "KR"},
    {"label": "SPAIN", value: "ES"},
    {"label": "SRI LANKA", value: "LK"},
    {"label": "ST. BARTHÉLEMY", value: "BL"},
    {"label": "ST. HELENA", value: "SH"},
    {"label": "ST. KITTS & NEVIS", value: "KN"},
    {"label": "ST. LUCIA", value: "LC"},
    {"label": "ST. MARTIN", value: "MF"},
    {"label": "ST. PIERRE & MIQUELON", value: "PM"},
    {"label": "ST. VINCENT & GRENADINES", value: "VC"},
    {"label": "SUDAN", value: "SD"},
    {"label": "SURINAME", value: "SR"},
    {"label": "SVALBARD & JAN MAYEN", value: "SJ"},
    {"label": "SWAZILAND", value: "SZ"},
    {"label": "SWEDEN", value: "SE"},
    {"label": "SWITZERLAND", value: "CH"},
    {"label": "SYRIA", value: "SY"},
    {"label": "TAIWAN", value: "TW"},
    {"label": "TAJIKISTAN", value: "TJ"},
    {"label": "TANZANIA", value: "TZ"},
    {"label": "THAILAND", value: "TH"},
    {"label": "TIMOR-LESTE", value: "TL"},
    {"label": "TOGO", value: "TG"},
    {"label": "TOKELAU", value: "TK"},
    {"label": "TONGA", value: "TO"},
    {"label": "TRINIDAD & TOBAGO", value: "TT"},
    {"label": "TUNISIA", value: "TN"},
    {"label": "TURKEY", value: "TR"},
    {"label": "TURKMENISTAN", value: "TM"},
    {"label": "TURKS & CAICOS ISLANDS", value: "TC"},
    {"label": "TUVALU", value: "TV"},
    {"label": "UGANDA", value: "UG"},
    {"label": "UKRAINE", value: "UA"},
    {"label": "UNITED ARAB EMIRATES", value: "AE"},
    {"label": "UNITED KINGDOM", value: "GB"},
    {"label": "UNITED STATES", value: "US"},
    {"label": "UNITED STATES MINOR OUTLYING ISLANDS", value: "UM"},
    {"label": "URUGUAY", value: "UY"},
    {"label": "UZBEKISTAN", value: "UZ"},
    {"label": "VANUATU", value: "VU"},
    {"label": "VATICAN CITY", value: "VA"},
    {"label": "VENEZUELA", value: "VE"},
    {"label": "VIETNAM", value: "VN"},
    {"label": "WALLIS & FUTUNA", value: "WF"},
    {"label": "WESTERN SAHARA", value: "EH"},
    {"label": "YEMEN", value: "YE"},
    {"label": "ZAMBIA", value: "ZM"},
    {"label": "ZIMBABWE", value: "ZW"}
]
